import React from "react";
import { useQuery } from "react-query";
import { handleFetchKybCountries } from "api/onboarding";

export function useKybCountries(options = {}) {
    return useQuery({
        queryKey: ["kyb-countries"],
        queryFn: async () => {
            const responseBody = await handleFetchKybCountries();
            const rawCountries =
                (Array.isArray(responseBody?.data) && responseBody.data) ||
                (Array.isArray(responseBody?.data?.countries) && responseBody.data.countries) ||
                (Array.isArray(responseBody?.countries) && responseBody.countries) ||
                (Array.isArray(responseBody) && responseBody) ||
                [];

            const countryOptions = rawCountries.map((country) => ({
                value: country.name,
                displayValue: country.name,
                code: country.code,
                continent: country.continent,
                flag: country.flag || "",
                imageUrl: country.imageUrl,
                searchLabel: country.name,
                label: (
                    <span className="flex items-center gap-3">
                        {country.imageUrl ? (
                            <img
                                src={country.imageUrl}
                                alt={`${country.name} flag`}
                                className="size-5 rounded-full object-cover"
                            />
                        ) : (
                            <span className="text-base">{country.flag || "🏳️"}</span>
                        )}
                        <span>{country.name}</span>
                    </span>
                ),
                raw: country,
            }));

            return {
                countries: rawCountries,
                countryOptions,
            };
        },
        staleTime: 1000 * 60 * 30, // 30 minutes cache
        ...options,
    });
}

export default useKybCountries;
